import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Pagination, InternalGrid, Box } from '@paygreen/paygreen-ui';

const AllCharitiesPagination = ({ getCharityListData, pageCount }) => {
    const [pageIndex, setPageIndex] = useState(0);

    // we create a ref to detect if component is mounted
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;

        getCharityListData({
            pageIndex,
        });

        return () => {
            isMounted.current = false;
        };
    }, [pageIndex, getCharityListData]);

    return (
        <>
            {pageCount > 1 && (
                <Box marginTop="md">
                    <InternalGrid
                        alignItems="center"
                        childrenMarginBottom="sm"
                        childrenMarginLateral="sm"
                        justifyContent="center"
                    >
                        <Pagination
                            pageCount={pageCount}
                            pageIndex={pageIndex}
                            colorTheme="quaternary"
                            gotoPage={setPageIndex}
                        />
                    </InternalGrid>
                </Box>
            )}
        </>
    );
};

AllCharitiesPagination.propTypes = {
    getCharityListData: PropTypes.func,
    pageCount: PropTypes.number,
};

export default withTranslation('common')(AllCharitiesPagination);
